import styled from 'styled-components';
import theme from '../theme'

export const Title = styled.div`
    font-family: 'Montserrat';
    font-size: 1.5rem;
    text-align: center;
    color: ${theme.colors.gray_9}
`

export const SubTitle = styled.div`
    font-family: 'Lato';
    font-size: 0.875rem;
    text-align: center;
    font-weight: 700;
    color: ${theme.colors.primary}
`

export const Copyright = styled.div`
    font-family: 'Lato';
    font-size: 0.75rem;
    text-align: center;    
    color: ${theme.colors.gray_5};
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;    
`

export const Question = styled.div`    
    padding-top: 4.5rem;         
    font-family: 'Montserrat';
    font-size: 1.5rem;    
    color: ${theme.colors.gray_9}
`

export const AnalysisTitle = styled.div`
    text-align: center;
    font-family: 'Montserrat';
    font-size: 1rem;    
    color: ${theme.colors.gray_9}
`

export const AnalysisHint = styled.div`
    text-align: center;
    font-family: 'Lato';
    font-size: 0.875rem;    
    color: ${theme.colors.gray_6}
`

export const VerseText = styled.div`
    text-align: center;
    font-family: 'Lora';
    font-size: 1.125rem;
    color: ${theme.colors.gray_9} 
`

export const VerseName = styled.div`
    text-align: center;
    font-family: 'Lora';
    font-size: 0.875rem;
    color: ${theme.colors.gray_7}
`

export const CTAText = styled.div`
    text-align: center;
    font-family: 'Lato';
    font-size: 0.875rem;
    color: ${theme.colors.gray_7}
`

export const ProductQuestion = styled.div`
    text-align: center;
    font-family: 'Montserrat';
    font-size: 1.125rem;
    color: ${theme.colors.gray_9}
`

export const ProductDescription = styled.div`
    text-align: center;
    font-family: 'Lato';
    font-size: 1rem;
    color: ${theme.colors.gray_8}
`